import { FormattedMessage } from "react-intl";
import { Button } from "@/components/design/Button";

interface PagerProps {
  // Zero-based; the label counts from 1 for the reader.
  page: number;
  totalPages: number;
  onChange: (next: number) => void;
}

// Renders nothing for a single page, so no callsite repeats that condition.
export function Pager({ page, totalPages, onChange }: PagerProps) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-center gap-3 px-2 py-2">
      <Button variant="secondary" size="sm" disabled={page <= 0} onClick={() => onChange(page - 1)}>
        <FormattedMessage id="common.prevPage" defaultMessage="Previous" />
      </Button>
      <span className="field-label text-ink/70">
        <FormattedMessage
          id="common.pageOf"
          defaultMessage="Page {page} of {total}"
          values={{ page: page + 1, total: totalPages }}
        />
      </span>
      <Button
        variant="secondary"
        size="sm"
        disabled={page >= totalPages - 1}
        onClick={() => onChange(page + 1)}
      >
        <FormattedMessage id="common.nextPage" defaultMessage="Next" />
      </Button>
    </div>
  );
}
